<template>
  <div class="map">
    <div class="google-map" id="map">
    </div>
  </div>
</template>

<script>
    import {modulgetRefDB,modulgetRefDBWhere} from "../../firebase/MainDBManager.js";
    import {modulMarkeronGoogleMaps} from "../../firebase/GMapFunction";

    export default {
        name: "GMap",
        props:['onlineusers'],
        data(){
            let ref;
            return {
                ref,
                holder3:this.onlineusers,
            }
        },
        methods:{
            renderMap(){
              const map = new google.maps.Map(document.getElementById('map'),{
                  center:{lat: this.onlineusers[0].lat[0],lng:this.onlineusers[0].lat[1] },
                  zoom: this.onlineusers[0].zoom,
                  maxZoom: 15,
                  minZoom:3,
                  streetViewControl: false
              });
                if (this.onlineusers[0].user==''){
                    this.ref= modulgetRefDB(this.onlineusers[0].colname, 'name');
                }
                else{
                    this.ref= modulgetRefDBWhere(this.onlineusers[0].colname, 'name',this.onlineusers[0].user);
                }
                modulMarkeronGoogleMaps(this.ref, map)

            },
        },
        mounted() {
            this.renderMap();
        }
    }
</script>

<style scoped>
  .google-map{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: #fff;
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
  }
</style>



// WEBPACK FOOTER //
// src/components/GMap/GMap.vue